export const validate = (group) => {
    let nameMatch = group.group_id.match('^[a-z0-9][a-z0-9_-]{0,39}$');
    if (!nameMatch) {
        return false;
    }

    return true;
};
